import ProjectScopeDocSidebarWidgetModule from './scope-doc-sidebar-widget.module'

export default ProjectScopeDocSidebarWidgetModule
